import { TokenCategoriesEnum } from "../enum/templateEnums/tokenCategories.enum";

class TokenConfig {
  readonly settingCategory = TokenCategoriesEnum.SETTING;
  readonly customCategory = TokenCategoriesEnum.CUSTOM;
  readonly userCategories = [this.settingCategory, this.customCategory];
  readonly objectCategories = [
    TokenCategoriesEnum.URL,
    TokenCategoriesEnum.USER,
    TokenCategoriesEnum.REPORT,
    TokenCategoriesEnum.THG,
    TokenCategoriesEnum.PARTNER,
    TokenCategoriesEnum.BILLING,
    TokenCategoriesEnum.FORM,
    TokenCategoriesEnum.REQUEST,
    TokenCategoriesEnum.SIGN,
    TokenCategoriesEnum.MY,
    TokenCategoriesEnum.APPRAISAL,
    TokenCategoriesEnum.ESTIMATE,
    TokenCategoriesEnum.RENTAL,
    TokenCategoriesEnum.CLEARANCE,
    TokenCategoriesEnum.CLEARANCE_APPROVAL,
    TokenCategoriesEnum.LEAD,
    TokenCategoriesEnum.PERSON,
    TokenCategoriesEnum.VEHICLE,
    TokenCategoriesEnum.INVOICE,
    TokenCategoriesEnum.BOOKING
  ];
  readonly predefinedCategories = [...this.objectCategories, ...this.userCategories];
}

export const TemplateTokenConfig = new TokenConfig();
